import { render, staticRenderFns } from "./icon-order-details.vue?vue&type=template&id=187e57f6&scoped=true&"
import script from "./icon-order-details.vue?vue&type=script&lang=js&"
export * from "./icon-order-details.vue?vue&type=script&lang=js&"
import style0 from "./icon-order-details.vue?vue&type=style&index=0&id=187e57f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e57f6",
  null
  
)

export default component.exports